import { Create, SimpleForm, useGetIdentity } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { QrCodeFormFields } from './QrCodeForm';

export const QrCodeCreate = () => {
  const { identity } = useGetIdentity();

  const transform = (data: Record<string, any>) => {
    const { no_expiry: noExpiry, ...rest } = data;
    return {
      ...rest,
      // The API expects the creator id inside the QR token payload
      created_by: identity?.id,
      qr_end_time: noExpiry || !rest.qr_end_time ? 'never' : rest.qr_end_time,
    };
  };

  return (
    <Create redirect="list" transform={transform}>
      <SimpleForm toolbar={<MyToolbar resource="qrcodes" />}>
        <MyFormContainer>
          <QrCodeFormFields isCreate />
        </MyFormContainer>
      </SimpleForm>
    </Create>
  );
};

export default QrCodeCreate;
